<template>
  <zm-dialog
    v-bind="$attrs"
    v-on="$listeners"
    class="opc-dialog"
    :class="{ 'opc-modal-dialog': isModal }"
    :show-close="!isModal"
  >
    <template v-if="showDefaultTitle" #title>
      <NavBack v-if="isModal" :backHandler="handleBeforeClose" />
      <h1 class="opc-dialog__header-title" :class="titleClass" v-if="$attrs.title" v-html="$attrs.title" />
    </template>
    <template v-for="(_, slotName) in $scopedSlots" #[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps"></slot>
    </template>
  </zm-dialog>
</template>

<script>
import NavBack from '@/components/nav-back.vue';

const TitleDirectionEnum = {
  left: 'left',
  right: 'right',
  center: 'center'
}

export default {
  name: 'BillingDialog',
  inheritAttrs: false,
  components: { NavBack },
  props: {
    titleDirection: {
      type: String,
      default: 'left',
    }
  },
  computed: {
    isModal() {
      return this.$context?.is?.modal;
    },
    showDefaultTitle() {
      if (this.$scopedSlots?.title) return false;

      return true;
    },
    titleClass() {
      const className = TitleDirectionEnum[this.titleDirection];
      return className ? `opc-dialog__header-title--${className}` : '';
    }
  },
  methods: {
    handleBeforeClose() {
      this.$emit('back-event');
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';
@import "@/styles/modal.scss";

.opc-dialog {
  .opc-dialog__header-title {
    display: flex;
    line-height: 150%;
    padding-top: 24px;
    font-size: 22px;
    font-weight: 700;

    &--left {
      justify-content: flex-start;
    }

    &--center {
      justify-content: center;
      padding-top: 0px;
      color: #00053d;
    }

    &--right {
      justify-content: flex-end;
    }
  }
}

</style>
